import { Grid, LinearProgress } from '@mui/material';

const getProgressValue = (left, full) => {
    if (!full || full <= 0) return 0;
    return Math.round((left / full) * 100);
};

const HolidayRangeItem = ({
    label,
    leftDays,
    fullDays,
    absenceTypeId=0,
    mobile = false,
    onClick,
}) => {
    const leftHours = leftDays * 8;
    const fullHours = fullDays * 8;

    if (mobile) {
        return (
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={12}>
                        <b className="holiday-label">{label}:</b>
                    </Grid>
                    {absenceTypeId!==2 && absenceTypeId!==10 && 
                    <Grid item xs={12}>
                        <a className="holiday-info" onClick={onClick}>
                            Zostało:{' '}
                            <span><b>
                                {leftDays} dni/{leftHours} godzin
                            </b>{' '}
                            z&nbsp;
                            <b>
                                {fullDays} dni/{fullHours} godzin
                            </b></span>
                        </a>

                        <div className="mt-5">
                            <LinearProgress
                                className="white-progress"
                                variant="determinate"
                                value={getProgressValue(leftDays, fullDays)}
                            />
                        </div>
                    </Grid>}
                    {(absenceTypeId===2 || absenceTypeId===10) && 
                    <Grid item xs={12}>
                        <a className="holiday-info" onClick={onClick}>
                            Zostało:{' '}
                            <span><b>
                                {leftDays} dni
                            </b>{' '}
                            z&nbsp;
                            <b>
                                {fullDays} dni
                            </b></span>
                        </a>

                        <div className="mt-5">
                            <LinearProgress
                                className="white-progress"
                                variant="determinate"
                                value={getProgressValue(leftDays, fullDays)}
                            />
                        </div>
                    </Grid>}
                </Grid>
                <Grid item xs={12}>
                    <br />
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid item xs={12}>
            <Grid container>
                <Grid item xs={3}>
                    <b>{label}: </b>
                </Grid>
                {absenceTypeId!==2 && absenceTypeId!==10 && 
                <Grid item xs={9}>
                    Zostało: {leftDays} (dni) {leftHours}(godziny)
                    <b>&nbsp;z</b> {fullDays}(dni) {fullHours}(godziny)
                </Grid>}
                {(absenceTypeId===2 || absenceTypeId===10) && 
                <Grid item xs={9}>
                    Zostało: {leftDays} (dni) 
                    <b>&nbsp;z</b> {fullDays}(dni)
                </Grid>}
            </Grid>
        </Grid>
    );
};

export default HolidayRangeItem;
